module.exports = __webpack_public_path__ + "static/media/landschaftsgrafik_man@2x.d42fe1a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landschaftsgrafik_man@2x.png
// module id = 1462
// module chunks = 0